import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsPower = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g>
        <path
          fill="currentColor"
          d="M17.2314281,6.105916l-0.0000019,0.0000029c-0.0723896-0.0723886-0.1447792-0.0723886-0.2895584-0.0723886
		c-0.1447773,0-0.2895584,0.0723886-0.361948,0.2171683c-0.0723896,0.0723896-0.0723896,0.2171679-0.0723896,0.3619475
		c0,0.1447783,0.0723896,0.2171683,0.2171688,0.2895579c2.3164654,1.5925689,3.6918659,4.2709832,3.6918659,7.0941749
		c0,4.7053213-3.8366451,8.614356-8.6143551,8.614356s-8.6143551-3.9090347-8.6143551-8.6867456
		c0-2.8231916,1.375401-5.4292164,3.6918669-7.0941763c0.0723901-0.0723901,0.1447797-0.1447783,0.2171698-0.2895579
		c0-0.1447783,0-0.2171683-0.0723901-0.361948C6.9521112,6.1059189,6.8073316,6.0335288,6.6625533,6.0335288
		c-0.0723901,0-0.2171698,0-0.2895579,0.0723901c-2.5336342,1.8097386-4.1262045,4.7053204-4.1262045,7.8180704
		c0,5.2844381,4.2709827,9.555419,9.5554209,9.555419s9.5554199-4.2709827,9.5554199-9.5554199
		C21.3576317,10.8112364,19.8374519,7.9156547,17.2314281,6.105916z"
        />
        <path
          fill="currentColor"
          d="M11.8022099,14.4307184c0.2895584,0,0.4343376-0.2171688,0.4343376-0.4343376V1.1834302
		c0-0.2895579-0.2171679-0.4343375-0.4343376-0.4343375s-0.4343376,0.2171695-0.4343376,0.4343375v12.7405605
		C11.3678722,14.2135487,11.5850401,14.4307184,11.8022099,14.4307184z"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsPower;
